import api from '@/helpers/api_helper';
import { apiUrls } from '@/constant/configure';
import spaceUserStore from '@/store/modules/spaceUserStore';
import userStore from '@/store/modules/userStore';
import { useSpaceUserV2Store } from '@/store';
import spaceUserV2Store, { BlockFormType, SpaceUserV2StatePatch } from '@/store/modules/spaceUserV2Store';

const StudioApiBase = apiUrls.studio;

export const getSpaceUserData = async (userId: string) => {
    const { setSpaceUserInfo } = spaceUserStore.getState();
    const { patchSpaceUserV2Info, clearUser, user_id } = spaceUserV2Store.getState();
    try {
        const { item } = await api
            .get(`/users/profile/by-userId/${userId}`, { baseURL: StudioApiBase })
            .then((r) => r.data);
        console.log('item::::', item);
        setSpaceUserInfo(item);

        // userId가 다르면 clearUser 후 즉시 새 데이터로 설정
        if (userId !== user_id) {
            clearUser();
            // clearUser 후 즉시 새 데이터 설정 (persist 저장 보장)
            patchSpaceUserV2Info({
                nickname: item?.nickname || '',
                path: item?.path || '',
                email: item?.email || '',
                user_id: userId,
                grade: item?.grade || 0,
                grade_name: item?.grade_name || '일반셀러',
                is_path_editable: item?.is_path_editable,
                path_editable_date: item?.path_editable_date,
            });
        } else {
            // 같은 userId면 기존 데이터 업데이트
            patchSpaceUserV2Info({
                nickname: item?.nickname || '',
                path: item?.path || '',
                email: item?.email || '',
                user_id: userId,
                grade: item?.grade || 0,
                grade_name: item?.grade_name || '일반셀러',
                is_path_editable: item?.is_path_editable,
                path_editable_date: item?.path_editable_date,
            });
        }
        return item;
    } catch (error) {
        throw error;
    }
};
export const checkSpaceIsOpened = async (userId: string) => {
    try {
        return await api.get(`/users/profile/by-userId/${userId}`, { baseURL: StudioApiBase }).then((r) => r.data);
    } catch (error: any) {
        console.log('error::::', error);
        if (error?.status === 404 || error?.statusCode === 404) {
            return { isNotOpened: true };
        }
        throw error;
    }
};
export const getSpaceDesignData = async (userId: string) => {
    const { setSpaceUserInfo } = spaceUserStore.getState();
    try {
        const { item } = await api
            .get(`/spacehome/${userId}/spacehome-data`, { baseURL: StudioApiBase })
            .then((r) => r.data);
        setSpaceUserInfo({ ...item });
        console.log(item);
        return item;
    } catch (error) {
        throw error;
    }
};
export const getSpaceBlockData = async (userId: string) => {
    const { patchSpaceUserInfo } = spaceUserStore.getState();
    try {
        return await api.get(`/spacehome/${userId}/block-data`, { baseURL: StudioApiBase }).then((r) => {
            patchSpaceUserInfo({ block_list: [...r.data.item_list] });
            return r;
        });
    } catch (error) {
        throw error;
    }
};
export const createSpaceProfile = async (body: sendSpaceProfileType) => {
    try {
        return await api.post(`/users/profile`, { ...body }, { baseURL: StudioApiBase }).then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const updateSpaceProfile = async (body: sendSpaceProfilePatchType) => {
    try {
        return await api.patch(`/users/profile`, { ...body }, { baseURL: StudioApiBase }).then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const postHeaderDesign = async (body: any) => {
    try {
        return await api.post(`/spacehome/design`, { ...body }, { baseURL: StudioApiBase }).then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const patchHeaderDesign = async (body: any) => {
    try {
        return await api.patch(`/spacehome/design`, { ...body }, { baseURL: StudioApiBase }).then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const postBlockOrder = async (body: { user_id: string; block_id_list: string[] }) => {
    try {
        return await api
            .post(`/spacehome/event-blocks/order/change`, { ...body }, { baseURL: StudioApiBase })
            .then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const deleteEventBlock = async (body: { user_id: string; block_id: string }) => {
    try {
        return await api
            .delete(`/spacehome/event-blocks`, { baseURL: StudioApiBase, data: { ...body } })
            .then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const createEventBlock = async (body: any) => {
    try {
        return await api.post(`/spacehome/event-blocks`, { ...body }, { baseURL: StudioApiBase }).then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const updateEventBlock = async (body: any) => {
    try {
        return await api.patch(`/spacehome/event-blocks`, { ...body }, { baseURL: StudioApiBase }).then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const postUserSpacePath = async (userId: string, path: string) => {
    // 스페이스홈 주소 변경
    try {
        return await api.post(`/users/profile/path`, { userId, path }, { baseURL: StudioApiBase });
    } catch (error) {
        throw error;
    }
};
export const checkDuplicateUrl = async (url: string) => {
    try {
        return await api.post(`/users/profile/path/check`, { path: url }, { baseURL: StudioApiBase }).then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const SchedulePostAPI = async (body: any) => {
    try {
        return await api
            .post(`/spacehome/event-blocks/schedule`, { ...body }, { baseURL: StudioApiBase })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const SchedulePatchAPI = async (body: any) => {
    try {
        return await api
            .patch(`/spacehome/event-blocks/schedule`, { ...body }, { baseURL: StudioApiBase })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const ScheduleDeleteAPI = async (body: any) => {
    try {
        return await api
            .delete(`/spacehome/event-blocks/schedule`, { baseURL: StudioApiBase, data: { ...body } })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const getBadgeList = async (userId: string) => {
    const { patchSpaceUserInfo } = spaceUserStore.getState();
    try {
        return await api.get(`/spacehome/${userId}/badge`, { baseURL: StudioApiBase }).then((r) => {
            console.log('r::::', r.data.item_list);
            patchSpaceUserInfo({ user_badge_list: [...r.data.item_list] });
            return r;
        });
    } catch (err) {
        throw err;
    }
};
export const createBadge = async (body: any) => {
    try {
        return await api.post(`/spacehome/badge`, { ...body }, { baseURL: StudioApiBase }).then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const deleteBadge = async (user_id: string, badge_id: string) => {
    try {
        return await api
            .delete(`/spacehome/user/${user_id}/badge/${badge_id}`, { baseURL: StudioApiBase })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const getOfferList = async (user_id: string, type: 'all' | 'keep' | 'deleted', queryParams: any) => {
    try {
        const offset = queryParams?.offset || 0;
        const limit = queryParams?.limit || 15;
        return await api
            .get(`/spacehome/${user_id}/suggest/business?type=${type}&offset=${offset}&limit=${limit}`, {
                baseURL: StudioApiBase,
            })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const getUnreadOfferCount = async (user_id: string) => {
    try {
        return await api
            .get(`/spacehome/${user_id}/suggest/business/unread`, { baseURL: StudioApiBase })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const updateUnreadOfferState = async (user_id: string, suggestion_id_list: string[]) => {
    try {
        return await api
            .patch(`/spacehome/suggest/business/read`, { user_id, suggestion_id_list }, { baseURL: StudioApiBase })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const changeDeleteOfferState = async (user_id: string, suggestion_id_list: string[]) => {
    try {
        return await api
            .patch(`/spacehome/suggest/business/delete`, { user_id, suggestion_id_list }, { baseURL: StudioApiBase })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const changeKeepOfferState = async (user_id: string, suggestion_id_list: string[]) => {
    try {
        return await api
            .patch(`/spacehome/suggest/business/keep`, { user_id, suggestion_id_list }, { baseURL: StudioApiBase })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const returnDeleteOfferState = async (user_id: string, suggestion_id_list: string[]) => {
    try {
        return await api
            .patch(
                `/spacehome/suggest/business/undo/delete`,
                { user_id, suggestion_id_list },
                { baseURL: StudioApiBase },
            )
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const returnKeepOfferState = async (user_id: string, suggestion_id_list: string[]) => {
    try {
        return await api
            .patch(`/spacehome/suggest/business/undo/keep`, { user_id, suggestion_id_list }, { baseURL: StudioApiBase })
            .then((r) => r);
    } catch (err) {
        throw err;
    }
};
export const studioYoutubeCrawler = async (url: string) => {
    try {
        return await api.get(`/youtube/video-info?url=${url}`, { baseURL: apiUrls.proxy2 }).then((r) => r);
        // return await api.get(`/spacehome/youtube/crawling?videoUrl=${url}`, { baseURL: StudioApiBase }).then(r => r)
    } catch (err) {
        throw err;
    }
};
interface sendSpaceProfileType {
    user_id: string;
    path: string;
    description?: string;
    user_img_url?: string;
}
interface sendSpaceProfilePatchType {
    user_id?: string;
    path?: string;
    description?: string;
    user_img_url?: string;
}

export type ExternalServiceType = 'inpock' | 'littly' | 'kemi';
export const getMigrateProfileLink = async (userId: string, type: ExternalServiceType, path: string) => {
    try {
        const payload = {
            serviceName: type,
            path,
        };
        return await api.post(`/spacehome/${userId}/migration/blocks`, { ...payload }, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};
export const getMigrateProfileLinkV2 = async (userId: string, type: ExternalServiceType, path: string) => {
    try {
        const payload = {
            serviceName: type,
            path,
        };
        return await api.post(`/v2/spacehome/${userId}/migration/blocks`, { ...payload }, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};

// 추가되는 갱신 API
export const getDesignDataV2 = async (userId: string) => {
    const { patchSpaceUserV2Info } = spaceUserV2Store.getState();
    try {
        return await api.get(`/v2/spacehome/${userId}/design`, { baseURL: apiUrls.studio }).then((r) => {
            patchSpaceUserV2Info({ ...r.data?.item });
            return r.data?.item;
        });
    } catch (error) {
        throw error;
    }
};
export const patchDesignDataV2 = async (userId: string, data: SpaceUserV2StatePatch) => {
    try {
        return await api.patch(`/v2/spacehome/${userId}/design`, { ...data }, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};
export const getEventBlockV2 = async (userId: string) => {
    const { patchSpaceUserV2Info, grade_name } = spaceUserV2Store.getState();
    const isSodomall = grade_name === '소도몰';
    const endpoint = isSodomall
        ? `/v2/spacehome/${userId}/event-blocks/gonggu`
        : `/v2/spacehome/${userId}/event-blocks`;
    try {
        return await api.get(endpoint, { baseURL: apiUrls.studio }).then((r) => {
            patchSpaceUserV2Info({ block_list: [...r.data.item_list] });
            return r.data.item_list;
        });
    } catch (error) {
        throw error;
    }
};

export const postEventBlockV2 = async (userId: string, block_type: string) => {
    try {
        return await api.post(`/v2/spacehome/${userId}/event-blocks`, { block_type }, { baseURL: apiUrls.studio }).then(
            (r) =>
                r.data as {
                    item: {
                        block_id: string;
                        block_content: {
                            on_off: boolean;
                            is_valid: boolean;
                            is_activated: boolean;
                            title: string;
                            sub_title: string;
                        };
                    };
                },
        );
    } catch (error) {
        throw error;
    }
};
export const patchEventBlockV2 = async (userId: string, blockId: string, data: any) => {
    try {
        return await api.patch(
            `/v2/spacehome/${userId}/event-blocks/${blockId}`,
            {
                block_content: {
                    ...data,
                },
            },
            { baseURL: apiUrls.studio },
        );
    } catch (error) {
        throw error;
    }
};
export const patchEventLinkBlockV2 = async (userId: string, blockId: string, data: any) => {
    try {
        return await api.patch(
            `/v2/spacehome/${userId}/event-blocks/${blockId}`,
            {
                block_type: 'link',
                block_content: {
                    ...data,
                },
            },
            { baseURL: apiUrls.studio },
        );
    } catch (error) {
        throw error;
    }
};

export const patchEventBlock = async ({
    userId,
    blockId,
    blockType,
    data,
}: {
    userId: string;
    blockId: string;
    blockType: BlockFormType;
    data: any;
}) => {
    try {
        return await api.patch(
            `/v2/spacehome/${userId}/event-blocks/${blockId}`,
            {
                block_type: blockType,
                block_content: {
                    ...data,
                },
            },
            { baseURL: apiUrls.studio },
        );
    } catch (error) {
        throw error;
    }
};

export const deleteEventBlockV2 = async (userId: string, blockId: string) => {
    try {
        return await api.delete(`/v2/spacehome/${userId}/event-blocks/${blockId}`, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};
export const postScheduleBlockV2 = async (userId: string, blockId: string) => {
    try {
        return await api
            .post(`/v2/spacehome/${userId}/event-blocks/${blockId}/schedule-blocks`, {}, { baseURL: apiUrls.studio })
            .then((r) => r.data);
    } catch (error) {
        throw error;
    }
};
export const patchScheduleBlockV2 = async (userId: string, blockId: string, scheduleId: string, data: any) => {
    try {
        return await api
            .patch(
                `/v2/spacehome/${userId}/event-blocks/${blockId}/schedule-blocks/${scheduleId}`,
                { block_content: { ...data } },
                { baseURL: apiUrls.studio },
            )
            .then((r) => r.data);
    } catch (error) {
        throw error;
    }
};
export const deleteScheduleBlockV2 = async (userId: string, blockId: string, scheduleBlockId: string) => {
    try {
        return await api.delete(`/v2/spacehome/${userId}/event-blocks/${blockId}/schedule-blocks/${scheduleBlockId}`, {
            baseURL: apiUrls.studio,
        });
    } catch (error) {
        throw error;
    }
};
export const putEventBlockOrderV2 = async (userId: string, idList: string[]) => {
    try {
        return await api
            .put(`/v2/spacehome/${userId}/event-blocks/order`, { block_id_list: idList }, { baseURL: apiUrls.studio })
            .then((r) => r.data);
    } catch (error) {
        throw error;
    }
};
export const getLinkMetadata = async (url: string) => {
    try {
        return await api.get(`/v2/spacehome/link-metadata?url=${url}`, { baseURL: apiUrls.studio }).then((r) => r.data);
    } catch (error) {
        throw error;
    }
};
export const getLinkMetadata2 = async (url: string) => {
    try {
        const { data } = await api.get(`/v2/spacehome/link-metadata?url=${url}`, { baseURL: apiUrls.studio });
        const { title = '', description = '', image = '' } = data.item;
        return {
            title,
            description,
            image,
        };
    } catch (error) {
        return {
            title: '',
            description: '',
            image: '',
        };
    }
};
interface ProfileLinkSignUpWithEmailProp {
    nickname: string;
    email: string;
    phoneNumber: string;
    password: string;
    // mallPath: string;
    imageUrl: string;
    smsMarketingConsented: boolean;
    emailMarketingConsented: boolean;
}
export const profileLinkSignUpWithEmail = async (body: ProfileLinkSignUpWithEmailProp) => {
    try {
        return await api.post(`/users/sign-up`, { ...body }, { baseURL: apiUrls.studio }).then((r) => r);
    } catch (error) {
        throw error;
    }
};

export const getThemeCategory = async () => {
    try {
        return await api
            .get(`/v2/spacehome/theme-category`, { baseURL: apiUrls.studio })
            .then((r) => r.data?.item_list || []);
    } catch (error) {
        throw error;
    }
};
export const getThemeList = async (categoryId: string) => {
    try {
        return await api
            .get(`/v2/spacehome/theme${!!categoryId ? `?category_id=${categoryId}` : ''}`, { baseURL: apiUrls.studio })
            .then((r) => r.data?.item_list || []);
    } catch (error) {
        throw error;
    }
};
